import { useMemo } from 'react';

import { TelemetryContentPlace } from '../../Player';
import { useChannelPlayerConfigHandler } from '../../channel-player/hooks/use-channel-player-config-handler';
import { useEpisodePlayerConfigHandler } from '../../episode-player/hooks/use-episode-player-config-handler';
import { useFilmPlayerConfigHandler } from '../../film-player/hooks/use-film-player-config-handler';
import { useStreamHandler } from '../../feature-player/hooks/config/use-stream-handler';
import { useTrailerPlayerConfigHandler } from '../../trailer-player/hooks/use-trailer-player-config-handler';
import { useSportPlayerConfigHandler } from '../../SportLiverPlayer/hooks/useSportPlayerConfigHandler';

export const usePlayerManagerStreamHandler = () => {
    const filmPlayerConfigHandler = useFilmPlayerConfigHandler();
    const episodePlayerConfigHandler = useEpisodePlayerConfigHandler();
    const channelPlayerConfigHandler = useChannelPlayerConfigHandler(
        useMemo(
            () => ({
                telemetryContentPlace: TelemetryContentPlace.Channel,
            }),
            []
        )
    );
    const trailerPlayerConfigHandler = useTrailerPlayerConfigHandler();
    const sportPlayerConfigHandler = useSportPlayerConfigHandler(
        useMemo(
            () => ({
                telemetryContentPlace: TelemetryContentPlace.SportChannel,
            }),
            []
        )
    );
    const handlers = useMemo(
        () => [
            filmPlayerConfigHandler,
            episodePlayerConfigHandler,
            channelPlayerConfigHandler,
            trailerPlayerConfigHandler,
            sportPlayerConfigHandler,
        ],
        [
            channelPlayerConfigHandler,
            episodePlayerConfigHandler,
            filmPlayerConfigHandler,
            trailerPlayerConfigHandler,
            sportPlayerConfigHandler,
        ]
    );

    return useStreamHandler(handlers);
};
